// Charge la base commune
// Styles librairies

// Styles custom
import './scss/pages/insurance'

require('./common.js')

// Scripts librairies

// actions principales communes à toutes les pages
// $(document).ready(function() {
//
//
// })
